import { render, staticRenderFns } from "./processImgs.vue?vue&type=template&id=39ec7008&scoped=true"
import script from "./processImgs.vue?vue&type=script&lang=js"
export * from "./processImgs.vue?vue&type=script&lang=js"
import style0 from "./processImgs.vue?vue&type=style&index=0&id=39ec7008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ec7008",
  null
  
)

export default component.exports